import TransactionRetryMain from '@src/components/Admin/TransactionRetry/TransactionRetryMain'
import PageContainer from '@src/components/Layout/PageContainer'
import PageHeader from '@src/components/Layout/PageHeader'
import { useTranslation } from 'react-i18next'

const TransactionRetryPage = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageHeader
        title={t('admin.transactionRetry.pageTitle')}
        breadcrumbs={{ current: t('admin.transactionRetry.pageTitle') }}
      />
      <PageContainer>
        <TransactionRetryMain />
      </PageContainer>
    </>
  )
}

export default TransactionRetryPage
